import axios from 'axios';

export const getScreenHostDetails = (token, userId) => {
    return axios.get(process.env.REACT_APP_API_URL + '/admin/screenHostDetails', {
        headers: { Authorization: token },
        params: { userId }
    });
};
